import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate, Trans} from "react-i18next";
import i18n from "i18next";

class Subtitle extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        return <div className={"text-subtitle"}>
            <b>{i18n.t(this.props.textResource, this.props)}</b>
            <br/>
        </div>
    }
}

export default translate("translations")(Subtitle);